module.exports = __webpack_public_path__ + "static/media/highlight.b02bec96.svg";